export default __webpack_public_path__ + "static/media/misc-fireplaceA-1920w.e7606ecc.webp";